
import asyncLoadOnScroll from './../utility/asyncLoadOnScroll'

export function animateOnScroll(selector, className) {
	const els = document.querySelectorAll(selector)
	const handler = el => el.classList.add(className)
	els.forEach(el => asyncLoadOnScroll(el, handler, -200))
}